import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NavigationContext } from './NavigationContext';
import { GlobalContext } from '../../auth/GlobalContext';
import LogoExploHorizontalBlanco from '../../../assets/brand/explo-horizontal-blanco.svg';
import { MenuTopBar } from '../../../app/menu/MenuTopBar';
import { SalirIcon } from '../..';

export const NavTopBar = (props: any) => {
	const UserGlobalContext = useContext(GlobalContext);
	const NavContext = useContext(NavigationContext);
	let { loading } = UserGlobalContext.userState;
	const [loginEmail, setLoginEmail] = useState('Cargando nombre...');

	useEffect(
		() => {
			let isSubscribed: boolean = true;
			if (isSubscribed) {
				UserGlobalContext.checkUser();
			}
			return () => {
				isSubscribed = false;
			};
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	useEffect(() => {
		if (!loading && UserGlobalContext?.userState?.user) {
			let { user }: any = UserGlobalContext.userState;
			setLoginEmail(user.username);
		}
		return () => { };
	}, [loading, UserGlobalContext]);

	return (
		<header className="nav-top-bar">
			
			<nav className="nav-top-bar-navigation">
				<div>

					<div  onClick={NavContext.navBarToggleClickHandler}>
						{/* <div className="toggle-button__line" />
						<div className="toggle-button__line" /> */}
					</div>
				</div>
				<div className="nav-top-bar-logo">
					<Link className="nav-top-bar-logo-link" to="/">
						<div className="LogoExploNavBar">
							<img src={LogoExploHorizontalBlanco} className="App-logoExplo" alt="logo" />
						</div>
					</Link>
				</div>
				<div className="nav-top-bar-right">
					<MenuTopBar />
					<div className="nav-top-bar-logout">
						<h6 className="logout-button-email">{loginEmail}</h6>
						<button className="logout-button" onClick={UserGlobalContext.signOut}>
							<h6 className="logout-button-text">Salir</h6>
							<SalirIcon />
						</button>
					</div>
				</div>
			</nav>
		</header>
	);
};
